const colors = {
  primary: '#dc3545',
  secondary: '#6c757d',
}

const partyColors = [
  {
    "Party": "WARISAN",
    "Colour": "#5ad2fc"
  },
  {
    "Party": "PIS",
    "Colour": "#0269ab"
  },
  {
    "Party": "GRS",
    "Colour": "#e3e3fc"
  },
  {
    "Party": "STARSABAH",
    "Colour": "#b2def3"
  },
  {
    "Party": "BN",
    "Colour": "#000080"
  },
  {
    "Party": "PN",
    "Colour": "#2f5772"
  },
  {
    "Party": "KDM",
    "Colour": "#ff9900"
  },
  {
    "Party": "UPKO",
    "Colour": "#800000"
  },
  {
    "Party": "PH",
    "Colour": "#d7282f"
  },
  {
    "Party": "PKS",
    "Colour": "#576baa"
  },
  {
    "Party": "ANAK NEGERI",
    "Colour": "#020605"
  },
  {
    "Party": "PPRS",
    "Colour": "#0101fe"
  },
  {
    "Party": "PBK",
    "Colour": "#f7d188"
  },
  {
    "Party": "RUMPUN",
    "Colour": "#7efa98"
  },
  {
    "Party": "SAPP",
    "Colour": "#85c226"
  },
  {
    "Party": "PR",
    "Colour": "#ef51a8"
  },
  {
    "Party": "SPP",
    "Colour": "#fff100"
  },
  {
    "Party": "GAS",
    "Colour": "#9999eb"
  },
  {
    "Party": "PBM",
    "Colour": "#7032a1"
  },
  {
    "Party": "ASPIRASI",
    "Colour": "#e4bc41"
  },
  {
    "Party": "BERSAMA",
    "Colour": "#ea9999"
  },
  {
    "Party": "PERPADUAN",
    "Colour": "#03ac5c"
  },
  {
    "Party": "Independent",
    "Colour": "#DCDCDC"
  }
]

/**
 * Get color for a party based on party_acronym_en
 * @param result - Either a result object with party_acronym_en or a string party acronym
 * @param justParty - If true, returns only { fill }, otherwise returns { fill, opacity }
 * @returns Color object with fill (and optionally opacity)
 */
export function getPartyColor(result: { party_acronym_en?: string } | string, justParty: boolean = false) {
  // Extract party acronym
  let partyAcronym: string;
  
  if (typeof result === 'string') {
    partyAcronym = result;
  } else {
    partyAcronym = result?.party_acronym_en || '';
  }
  
  // Normalize: BEBAS means Independent
  if (partyAcronym === 'BEBAS' || partyAcronym.toUpperCase() === 'BEBAS' 
  || partyAcronym.toUpperCase().includes('INDEPENDENT') || partyAcronym.toUpperCase().includes('BEBAS')) {
    partyAcronym = 'Independent';
  }
  
  // Look up color in partyColors array
  const partyEntry = partyColors.find(
    p => p.Party.toUpperCase() === partyAcronym.toUpperCase()
  );
  
  const color = partyEntry?.Colour || '#808080'; // Default gray if not found
  
  if (justParty) {
    return { fill: color };
  }
  
  return {
    fill: color,
    opacity: 0.7 // Default opacity, can be adjusted based on vote share if needed
  };
}

export { partyColors };
export default colors